import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnDestroy
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PATH_OLD_MANAGER } from '../../constants';
import { IframeManagerWindow } from './iframeManagerWindow';
import { VersionService } from '../version/version.service';

import { Subscription, fromEvent } from 'rxjs';
import { PageLoaderService } from '../components/loader/page-loader.service';

@Component({
  selector: 'ls-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
  exportAs: 'appIframe'
})
export class IframeComponent implements OnInit, OnDestroy {
  @Input()
  public page: string;
  @Input()
  public prefix: string;
  @Input()
  public noSuffix = false;

  @ViewChild('iframe')
  private _iframeWindow: ElementRef;
  private _path: SafeResourceUrl;
  private iFrameLoadedSub: Subscription;

  constructor(
    private sanitizer: DomSanitizer,
    private versionService: VersionService,
    private pageLoader: PageLoaderService
  ) {}

  public ngOnInit(): void {
    if (this.prefix) {
      this.path = this.getUrl(this.prefix, this.page);
    } else {
      this.path = this.getUrl(PATH_OLD_MANAGER, this.page);
    }

    this.iFrameLoadedSub = fromEvent(
      this._iframeWindow.nativeElement,
      'load'
    ).subscribe(() => {
      this.pageLoader.setLoaded();
    });
  }

  public ngOnDestroy(): void {
    this.iFrameLoadedSub.unsubscribe();
  }

  public get path(): SafeResourceUrl {
    return this._path;
  }

  public set path(value: SafeResourceUrl) {
    this._path = value;
  }

  public get iframeWindow(): IframeManagerWindow {
    return this._iframeWindow.nativeElement.contentWindow;
  }

  private getUrl(prefix: string, page: string): SafeResourceUrl {
    let url: string = prefix + page;
    if (!this.noSuffix) {
      // DO NOT USE version, this is used in the old manager to check if you are using manage my restaurant ...
      url +=
        (url.indexOf('?') > -1 ? '&' : '?') +
        'embed=true' +
        '&managerVersion=' +
        this.versionService.managerVersion;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
